import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bdo-section-headline',
    templateUrl: './section-headline.component.html',
    styleUrls: ['./section-headline.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SectionHeadlineComponent {

}
